import { render } from "./view-object-list.vue?vue&type=template&id=072b5cb2"
import script from "./view-object-list.vue?vue&type=script&setup=true&lang=js"
export * from "./view-object-list.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/object/view-object-list/view-object-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "072b5cb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('072b5cb2', __exports__)) {
    api.reload('072b5cb2', __exports__)
  }
  
  module.hot.accept("./view-object-list.vue?vue&type=template&id=072b5cb2", () => {
    api.rerender('072b5cb2', render)
  })

}


export default __exports__